import { useTermApi } from "./useTerm.api";

export const { useGetTermsByCompanyQuery, useGetTermsUserByCompanyQuery, useLazyGetTermsUserByCompanyQuery, useSaveTermsAuthorizationMutation } = useTermApi;
